import React from 'react';
import { Stack, Chip } from '@mui/material';
import { Person, CalendarToday } from '@mui/icons-material';

interface NoteMetadataSectionProps {
  addedBy: string | undefined;
  addDate: string;
  canDelete: boolean;
  formatDate: (dateString: string) => string;
}

export const NoteMetadataSection: React.FC<NoteMetadataSectionProps> = ({
  addedBy,
  addDate,
  canDelete,
  formatDate
}) => {
  return (
    <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
      <Chip
        icon={<Person />}
        label={addedBy || 'Unknown User'}
        variant="outlined"
        sx={{
          borderColor: canDelete ? '#10b981' : '#3b82f6',
          color: canDelete ? '#10b981' : '#3b82f6',
          '& .MuiChip-icon': {
            color: canDelete ? '#10b981' : '#3b82f6'
          }
        }}
      />
      <Chip
        icon={<CalendarToday />}
        label={formatDate(addDate)}
        variant="outlined"
        sx={{
          borderColor: '#64748b',
          color: '#64748b',
          '& .MuiChip-icon': {
            color: '#64748b'
          }
        }}
      />
      {canDelete && (
        <Chip
          label="Your Note"
          size="small"
          sx={{
            backgroundColor: '#dcfce7',
            color: '#166534',
            fontWeight: 500
          }}
        />
      )}
    </Stack>
  );
};
